import React, { useEffect } from 'react';
import { OverviewCourseDetailProps } from './OverviewCourseDetail.props';
import { Box, Button, Stack } from '@mui/material';
import { LeftCardDetail } from '../../components/LeftCardDetail';
import { useDispatch } from 'react-redux';

import './OverviewCourseDetail.css';
import './styles/ipad.css';
import './styles/mobile.css';
import { useAppSelector } from '../../redux/hooks';
import {
  trainingCourseDetailEvents,
  trainingCourseDetailEventsDataSelector
} from '../../redux/trainingCourseDetailSlice';
import { getCurrentCellStore, handleStartCourse } from '../../utils/util';
import {CATEGORY_TYPE, STATUS_COURSE, TYPE_LETF_CARD_DETAIL} from '../../constants/constants';
import { useLocation } from "react-router-dom";
import ChangeWorkSpace from "../../hoc/changeWorkSpace";
import {LoadingPage} from "../../components/LoadingPage";
import {getTrainingLink} from "../../api/platform";
import { getCoursePolicyEvents } from '../../redux/coursePolicySlice';

const OverviewCourseDetailComponent: React.FC<OverviewCourseDetailProps> = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch<any>();
  const { courseDetails, isLoading } = useAppSelector(trainingCourseDetailEventsDataSelector);
  const currentCellStore = getCurrentCellStore();
  const pathSubstrings = pathname.split('/');
  const courseId = pathSubstrings[3];
  useEffect(() => {
    if (courseId) {
      dispatch(trainingCourseDetailEvents({
        student_id: currentCellStore?.student_id,
        campaign_id: courseId
      }));
    }
  }, [courseId]);

  useEffect(() => {
    if(courseDetails?.training_result_id) {
      dispatch(getCoursePolicyEvents(courseDetails?.training_result_id));
    }
  }, [courseDetails])

  const checkStartCourse =(value:any)=> {
    const params={
      course_id: value?.course_id,
      campaign_id: value?.campaign_id,
      token_1: value?.token_1,
      token_2: value?.token_2,
    }
    getTrainingLink(params).then((res: any)=>{
      if(res && res.data){
        handleStartCourse(value.token_1, value.token_2);
      }
    }).catch((e:any) =>{
    console.log(e)})
  }
  return (
    <>
      {!isLoading && <Box
      className={'box-course-page-detail'}
      sx={{
        backgroundColor: '#ffffff',
        padding: '0 23px 30px',
      }}
    >
      <LeftCardDetail leftCardDetailsData={courseDetails} type={TYPE_LETF_CARD_DETAIL.GRADES} />
      <Stack direction={'row'} justifyContent='flex-end' alignItems='center' mt={'24px'}>
        <Button
          variant={'outlined'}
          data-testid={'btn-start-overview-course-detail-test'}
          className={'btn-detail-start-courses'}
          disabled={!courseDetails?.token_1 || !courseDetails?.token_2 || (courseDetails?.campaign_category === CATEGORY_TYPE.QUESTIONNAIRE && courseDetails?.training_label === STATUS_COURSE.QUESTIONNAIRE)}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            checkStartCourse(courseDetails)
          }}
        >
          Start Course
        </Button>
      </Stack>
    </Box>}
    <LoadingPage open={isLoading} />
  </>
  );
};

export const OverviewCourseDetail = ChangeWorkSpace(OverviewCourseDetailComponent);